/**
 * 千牛下载文件api
 */
export default async function downloadFile(url: string) {
    // @ts-ignore
    const result = await my.downloadFile({
        url,
    });

    if (result?.["success"] === true && result?.["apFilePath"]) {
        return result?.["apFilePath"] as string;
    }

    throw new Error(`下载文件失败:${JSON.stringify(result)}`);
}
